import { useLocation } from 'react-router-dom';
import { useAppSelector } from '@/app/store';
import { FullPageLoader } from '@/shared/components/ui/LoadingSpinner';
import { redirectToLogin } from '@/shared/api/axios.config';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAppSelector((state) => state.auth);
  const location = useLocation();

  if (isLoading) {
    return <FullPageLoader message="Checking authentication..." />;
  }

  if (!isAuthenticated) {
    // Redirect to external login
    redirectToLogin(location.pathname);
    return <FullPageLoader message="Redirecting to login..." />;
  }

  return <>{children}</>;
}

